import { FormlyFieldConfig } from '@ngx-formly/core';
import { v4 as uuid } from 'uuid';
import { questionComponents } from './questions';

const vehicleSelection = (isCustomerForm = false) => {
  return {
    id: 0,
    label: 'Vehicle Selection',
    value: 'vehicleSelection',
    src: 'assets/icons/select-menu.svg',
    type: 'question-group',
    wrappers: ['question-panel'],
    key: uuid(),
    templateOptions: {
      label: "Can you tell us which vehicle you're insuring?",
    },
    fieldGroup: [
      questionComponents.vin(isCustomerForm),
      questionComponents.vehicleYear(isCustomerForm),
      questionComponents.vehicleMake(isCustomerForm),
      questionComponents.vehicleModel(isCustomerForm),
      questionComponents.bodyStyle(isCustomerForm),
    ],
  };
};

const vehicleUsage = (isCustomerForm = false) => {
  return {
    id: 1,
    label: 'Vehicle Usage',
    value: 'vehicleUsage',
    src: 'assets/icons/select-menu.svg',
    type: 'question-group',
    wrappers: ['question-panel'],
    key: uuid(),
    templateOptions: {
      label: 'How do you primarily use the vehicle',
    },
    fieldGroup: [
      questionComponents.primaryUse(isCustomerForm),
      questionComponents.ownershipType(isCustomerForm),
      questionComponents.purchaseDate(isCustomerForm),
      questionComponents.annualMiles(isCustomerForm),
    ],
  };
};

// TODO : driverInfo uses the original address rather than v2
const driverInfo = (isCustomerForm = false) => {
  const address = questionComponents.address(isCustomerForm);
  return {
    id: 2,
    label: 'Driver Info',
    value: 'driverInfo',
    src: 'assets/icons/select-menu.svg',
    type: 'question-group',
    wrappers: ['question-panel'],
    key: uuid(),
    templateOptions: {
      label: 'Can you tell us about yourself?',
    },
    fieldGroup: [
      questionComponents.firstName(isCustomerForm),
      questionComponents.lastName(isCustomerForm),
      questionComponents.birthday(isCustomerForm),
      ...address.data,
    ],
  };
};

const driverGender = (isCustomerForm = false) => {
  return {
    id: 3,
    label: 'Driver Gender',
    value: 'driverGender',
    src: 'assets/icons/select-menu.svg',
    type: 'question-group',
    wrappers: ['question-panel'],
    key: uuid(),
    templateOptions: {
      label: 'What is your gender?',
    },
    fieldGroup: [questionComponents.gender(isCustomerForm)],
  };
};
const driverOccupation = (isCustomerForm = false) => {
  return {
    id: 4,
    label: 'Driver Occupation',
    value: 'driverOccupation',
    src: 'assets/icons/select-menu.svg',
    type: 'question-group',
    wrappers: ['question-panel'],
    key: uuid(),
    templateOptions: {
      label: 'What do you do for a living?',
    },
    fieldGroup: [
      questionComponents.educationLevel(isCustomerForm),
      questionComponents.industry(isCustomerForm),
      questionComponents.occupation(isCustomerForm),
    ],
  };
};
const driverLicense = (isCustomerForm = false) => {
  return {
    id: 4,
    label: 'Driver License',
    value: 'driverLicense',
    src: 'assets/icons/select-menu.svg',
    type: 'question-group',
    wrappers: ['question-panel'],
    key: uuid(),
    templateOptions: {
      label: 'What about your license information?',
    },
    fieldGroup: [
      questionComponents.driversLicenseNumber(isCustomerForm),
      questionComponents.licenseState(isCustomerForm),
      questionComponents.ageLicensed(isCustomerForm),
    ],
  };
};

const repeatAddAnother = (repeatLabel: string) => {
  const selectBox: FormlyFieldConfig = questionComponents.selectBox(true, [
    { label: `Yes, add another ${repeatLabel}`, value: true },
    { label: `Done adding ${repeatLabel}s`, value: false },
  ]);
  selectBox.templateOptions = {
    ...selectBox.templateOptions,
    ignoreValue: true,
    repeatAddAnother: true,
    preventDelete: true,
    preventDuplicate: true,
    preventConditional: true,
    preventAddQuestion: true,
    required: true,
  };
  return {
    type: 'question-group',
    wrappers: ['question-panel'],
    key: uuid(),
    templateOptions: {
      label: `Would you like to add another ${repeatLabel}?`,
      repeatAddAnother: true,
      preventDelete: true,
      preventDuplicate: true,
      preventConditional: true,
      preventAddQuestion: true,
      preventDrag: true,
    },
    fieldGroup: [selectBox],
  };
};

const priorInsurance = (isCustomerForm = false) => {
  return {
    type: 'question-group',
    wrappers: ['question-panel'],
    key: uuid(),
    templateOptions: {
      label: 'Please provide the following information',
    },
    fieldGroup: [
      {
        key: uuid(),
        type: 'address',
        templateOptions: {
          label: 'Current Address',
          required: '',
          className: isCustomerForm ? 'xilo-input' : 'intake-input',
          placeholder: 'Current Address',
        },
      },
      questionComponents.email(isCustomerForm),
      questionComponents.phone(isCustomerForm),
      {
        key: uuid(),
        type: 'checkbox',
        templateOptions: {
          text: 'Has Prior Insurance',
          label: 'Checkbox',
          className: isCustomerForm ? 'xilo-input' : 'intake-input',
          placeholder: 'Checkbox',
        },
      },
    ],
  };
};

const hasIncident = (isCustomerForm = false) => {
  const options = [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
  ];
  const hasIncident = questionComponents.selectBox(isCustomerForm, options);
  hasIncident.label = 'Has incident';
  hasIncident.templateOptions.label = 'Has incident';
  hasIncident.templateOptions['required'] = true;
  return {
    type: 'question-group',
    wrappers: ['question-panel'],
    key: uuid(),
    templateOptions: {
      label:
        'Have you had any accidents, violations, or claims in the past 5 years?',
    },
    fieldGroup: [hasIncident],
  };
};

const incident = (isCustomerForm = false) => {
  const incidentDescription = questionComponents.incidentDescription(
    isCustomerForm
  );
  const incidentDate = questionComponents.incidentDate(isCustomerForm);
  return {
    type: 'question-group',
    wrappers: ['question-panel'],
    key: uuid(),
    templateOptions: {
      label: 'Please describe the incident',
    },
    fieldGroup: [incidentDate, incidentDescription],
  };
};

export const questionGroupComponents = {
  vehicleSelection,
  vehicleUsage,
  driverInfo,
  driverGender,
  driverOccupation,
  driverLicense,
  repeatAddAnother,
  priorInsurance,
  incident,
  hasIncident,
};
